let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9OSao")).then(() => parcelRequire('jjM3c'));